import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import { verifySSODetails } from '../../../helpers/utils';

const UserDataLoader = () => {
  const dispatch = useDispatch();
  const pageType = useSelector((state) => get(state, ['qt', 'pageType']));
  const isSubscriber = useSelector((state) => get(state, ['userData', 'isSubscriber'], null));
  const config = useSelector((state) => get(state, ['qt', 'config'], null));
  const integrations = useSelector((state) => get(state, ['qt', 'config', 'integrations'], {}));
  const budget = useSelector((state) => get(state, ['qt', 'config', 'features', 'budget'], {}));

  useEffect(() => {
    if (!pageType) return; // Wait until pageType is set

    const url = new URL(window?.location?.href);
    const client_id = integrations?.sso?.client_id;
    const client_secret = integrations?.sso?.client_secret;
    const authCode = url?.searchParams?.get('authorizationCode');
    const accessToken = document?.cookie
      ?.split(';')
      ?.find((c) => c.indexOf('sso_access_token') > -1);
    const environment = config?.publisher?.environment;
    const accesstypeJwtSecret = integrations?.accesstype?.jwtSecret;
    const metypeJwtSecret = integrations?.metype?.jwtSecret;
    const LOGIN_SUCCESS_FLAG = 'loginSignupSuccessTriggered';

    const saveAuthCookies = async () => {
      await verifySSODetails({
        authCode,
        accessToken,
        client_id,
        client_secret,
        environment,
        dispatch,
        accesstypeJwtSecret,
        metypeJwtSecret,
        pageType,
        budget
      });
    };
    saveAuthCookies();

    if (window?.location?.search === '?logoutAction=success') {
      window.history.replaceState(null, '', window.location.pathname);
      localStorage.setItem(LOGIN_SUCCESS_FLAG, 'false');
    }
    if (window?.location?.search === '?logoutAction=failure') {
    }
  }, [isSubscriber, pageType]);

  return null;
};

export default UserDataLoader;
